import axios from "axios";
import UidEmailRoleMatch from "../../constants/uidEmailRoleMatch";

interface ResultArray {
  sr_no: number;
  lov_type: string;
  lov_display_value: string;
  lov_value: string;
  is_active: boolean;
}

interface ResultBody {
  count: number;
  prev: null;
  current: number;
  next: number;
  total_pages: number;
  result: Array<ResultArray>;
}

interface ResponseBody {
  jsonrpc: string;
  id: null;
  result: ResultBody;
}

export const getIndividualDesignation = (sessionId: string | null) => {
  const UidEmailRole = UidEmailRoleMatch();

  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/read/many/tradexwbench.list_of_value_master`,
      {
        params: {
          ...UidEmailRole,
          filter:
            "[('lov_type','in',['RELATED_INDIVIDUAL_DESIGNATION']),('is_active', '=', 'true')]",
          query: "{sr_no,lov_type,lov_display_value,lov_value,is_active}",
          order: "sr_no asc",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response): ResponseBody => response.data)
    .catch((err) => err);
};
